/**
 * /campaigns/:id/jobs — list of brief submissions (jobs) for this
 * campaign. Each row links into the per-job variant + render view.
 *
 * Jobs are loaded once in the parent CampaignDetail and passed via
 * outlet context, so this tab is presentational only.
 */

import { Link } from 'react-router-dom';
import { useCampaignContext } from '../CampaignDetail';

const STATUS_LABELS: Record<string, string> = {
  brief: 'Brief',
  script_generating: 'Generating script…',
  script_ready: 'Variants ready',
  variant_approved: 'Variant approved',
  audio_generating: 'Generating voiceover…',
  render_queued: 'Render queued',
  rendering: 'Rendering…',
  done: 'Done',
  failed: 'Failed',
};

export function JobsListTab() {
  const { campaign, jobs } = useCampaignContext();

  if (jobs.length === 0) {
    return (
      <div
        className="card"
        style={{ textAlign: 'center', padding: 32, color: 'var(--color-text-muted)' }}
      >
        <p style={{ marginBottom: 16 }}>No briefs submitted yet.</p>
        <Link to={`/campaigns/${campaign.id}/brief`} className="btn btn-primary">
          Submit your first brief
        </Link>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {jobs.map((job) => (
        <Link
          key={job.id}
          to={`/campaigns/${campaign.id}/jobs/${job.id}`}
          className="card"
          style={{
            display: 'grid',
            gridTemplateColumns: '120px 100px 80px 1fr auto',
            gap: 12,
            alignItems: 'center',
            padding: '12px 16px',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <strong style={{ fontSize: 13, textTransform: 'capitalize' }}>{job.platform}</strong>
          <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>{job.tone}</span>
          <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>
            {job.duration_seconds}s
          </span>
          <span style={{ fontSize: 13 }}>{STATUS_LABELS[job.status] ?? job.status}</span>
          <span style={{ fontSize: 11, color: 'var(--color-text-muted)' }}>
            {new Date(job.created_at).toLocaleString(undefined, {
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </Link>
      ))}
    </div>
  );
}
